const extractFromCookies = (wantedDataKey = ' ', cookiesString = '') => {
  const getWantedData = cookiesString.match(new RegExp(`(^| )${wantedDataKey}=([^;]+)`));
  const wantedData = getWantedData ? getWantedData[2] : null;

  return wantedData;
};

export default extractFromCookies;
